import React from "react";
import { cn } from "./utils";

export default function FormField({
  label,
  hint = "",
  error = "",
  className = "",
  labelClassName = "",
  children,
}) {
  return (
    <label className={cn("block space-y-1.5", className)}>
      {label ? (
        <span className={cn("block text-xs font-medium uppercase tracking-wide text-slate-600", labelClassName)}>
          {label}
        </span>
      ) : null}
      {children}
      {error ? <span className="block text-xs text-rose-700">{error}</span> : null}
      {!error && hint ? <span className="block text-xs text-slate-500">{hint}</span> : null}
    </label>
  );
}
